import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { WaveDivider } from './WaveDivider';
export function ProblemSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  const paragraphs = ['Para nosotros, el trabajo en este país es supervivencia. Por eso, un ataque de pánico o una crisis de nervios en el horario laboral no es solo un problema de salud; es una amenaza directa a tu estabilidad y al futuro de tu familia.', 'Sientes que tienes que ser de hierro. Te escondes en el baño para respirar, te muerdes los labios para no explotar ante un jefe injusto, y llegas a casa tan agotado que ya no tienes paciencia para tus hijos.', 'Estás viviendo en "alerta roja" constante, y eso te está enfermando el cuerpo y el alma.'];
  return <section className="bg-[#1a2e4a] relative" data-id="element-110">
      <WaveDivider fillColor="#0f1b2d" flip data-id="element-111" />

      <div ref={ref} className="py-16 md:py-24 px-4" data-id="element-112">
        <div className="max-w-3xl mx-auto" data-id="element-113">
          {paragraphs.map((text, index) => <motion.p key={index} initial={{
          opacity: 0,
          y: 30
        }} animate={isInView ? {
          opacity: 1,
          y: 0
        } : {}} transition={{
          duration: 0.7,
          delay: index * 0.2
        }} className={`text-lg md:text-xl leading-relaxed mb-6 ${index === paragraphs.length - 1 ? 'text-amber-400 font-semibold text-xl md:text-2xl' : 'text-gray-200'}`} data-id="element-114">
              {text}
            </motion.p>)}
        </div>
      </div>

      <WaveDivider fillColor="#f8fafc" data-id="element-115" />
    </section>;
}